import axios from 'axios';
import { get } from 'lodash-es';
import { from } from 'rxjs';

export const getStore = async (guid) => {
  try {
    const request = await axios.get(`/store/${guid}`);
    const result = get(request, 'data') || [];
    return result;
  } catch (error) {
    throw new Error(`Error getting store data : ${error?.message}`);
  }
};

export const saveStoreSettings = async (guid, settings) => {
  const request = await axios.put(`/store/${guid}`, settings);
  const response = get(request, 'data');
  return response;
};

export const getStoreActivity = async (guid, skipCount = 0) => {
  try {
    const queryParams = new URLSearchParams('');
    queryParams.append('size', 5);
    if (skipCount > 0) {
      queryParams.append('skipCount', skipCount);
    }
    const request = await axios.get(`/store/${guid}/activity?${queryParams.toString()}`);
    const result = get(request, 'data.events') || [];
    return result;
  } catch (error) {
    throw new Error(`Error getting store activity data : ${error?.message}`);
  }
};

export const getBrandingDefaults = async () => {
  const response = await axios.get('/branding/settings/store');
  const result = response?.data;
  return result;
};

export const saveBrandingDefaults = async (settings) => {
  const response = await axios.put('/branding/settings/store', settings);
  const result = response?.data;
  return result;
};

export const getCustomBranding = async (guid) => {
  try {
    const request = await axios.get(`/branding/settings/store/${guid}`);
    const result = request?.data;
    return result;
  } catch (error) {
    throw new Error(`Error getting store's custom branding : ${error?.message}`);
  }
};

export const checkEmailVerificationStatus = (emailAddress) => {
  const getResults = axios
    .post(`/account/checkEmailVerificationStatus?emailAddress=${encodeURIComponent(emailAddress)}`)
    .then((response) => {
      const { data } = response;
      return data;
    });
  return from(getResults);
};

export const verifyEmailAddress = async (emailAddress) => {
  const response = await axios.post(`/account/verifyemailaddress?emailAddress=${encodeURIComponent(emailAddress)}`);
  return response;
};

export const completeEmailVerification = async (token) => {
  const response = await axios.post('/account/completeEmailVerification', {
    token,
  });
  return response;
};

export const updateCustomBranding = async (guid, settings) => {
  const request = await axios.put(`/branding/settings/store/${guid}`, settings);
  const result = request?.data;
  return result;
};

export const updateStoreLogo = async (guid, file) => {
  const formData = new FormData();
  formData.append('logoFile', file);
  const response = await axios.put(`/store/${guid}/logo`, formData, {
    headers: {
      ContentType: 'multipart/form-data',
    },
  });
  const result = response?.data ?? [];
  return result;
};

export const deleteStoreLogo = async (guid) => {
  const response = await axios.delete(`/store/${guid}/logo`);
  return response;
};

export const getDoesStoreHaveSettings = async (storeGuid, isAdmin) => {
  const request = await axios.get(`/store/doesStoreHaveSettings?storeGuid=${storeGuid}&isAdmin=${isAdmin}`);
  const result = get(request, 'data') || false;
  return result;
};

const BACKGROUND_IMPORT_MODE_MAP = {
  background: 'manual',
  autoBackground: 'automatic',
};

export const enableBackgroundImport = async (storeGuid, newImportMode) => {
  const request = await axios.post(`/store/${storeGuid}/background-import/enable`, {
    importMode: BACKGROUND_IMPORT_MODE_MAP[newImportMode] ?? 'manual',
  });
  return get(request, 'data');
};

export const disableBackgroundImport = async (storeGuid, newImportMode) => {
  const request = await axios.post(`/store/${storeGuid}/background-import/disable`, {
    newImportMode,
  });
  return get(request, 'data');
};
